import { render, staticRenderFns } from "./ListRotaSlaView.vue?vue&type=template&id=0b192eaf&"
import script from "./ListRotaSlaView.vue?vue&type=script&lang=ts&"
export * from "./ListRotaSlaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports